
/**
 * LOADER
 */
function loaderShow() {
    loader.fadeIn(200);
}
function loaderClose() {
    loader.fadeOut(200);
}

//data- loader
$("[data-loader]").click(function () {
    loader.fadeIn(200);
});
